<template>
  <div class="C_Date">
    {{ currentValue }}
  </div>
</template>

<script>
/**
 * Using Moment.js
 * https://momentjs.com/
 */

import Vue from 'vue';
import moment from 'moment';
import 'moment-timezone';

import getTimezoneAbbreviation from '@/lib/timezones';

const customFormats = {
  en: {
    YtoM: 'MMMM YYYY',
    YtoSec: 'LLL',
  },
  ja: {
    YtoM: 'YYYY年MM月',
    YtoSec: 'll a h:mm:ss',
  },
};

export default Vue.extend({
  name: 'CDate',
  props: {
    value: {
      type: [String, Date, Object],
    },
    format: {
      type: String,
      default: 'L',
    },
    utc: {
      type: Boolean,
    },
  },
  data() {
    return {
      timezoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  },
  computed: {
    currentValue() {
      if (!this.value) return '-';
      const utcTime = moment.utc(this.value);

      if (this.utc)
        return moment(this.value)
          .utc()
          .format(this.currentFormat);

      return `${moment
        .tz(utcTime, this.timezoneName)
        .format(this.currentFormat)} (${getTimezoneAbbreviation(this.timezoneName)})`;
    },
    /**
     * currentFormat - 特定のフォーマットの場合、customFormatsを利用する。
     * @returns {string} - Format for moment.js
     */
    currentFormat() {
      if (this.format === 'YtoM' || this.format === 'YtoMinute' || this.format === 'YtoSec') {
        const locale = moment.locale();
        return customFormats[locale][this.format];
      }
      return this.format;
    },
  },
});
</script>

<style lang="scss" scoped>
.C_Date {
  display: inline-block;
}
</style>
